import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PaymentService } from '../../../../../../../../../services/payment/payment.service';
import { RecipientOption } from '../private-event-request-payment-modal/private-event-request-payment-modal.component';

@Component({
  selector: 'app-private-event-resend-requested-payment-email-modal',
  templateUrl: './private-event-resend-requested-payment-email-modal.component.html',
  styleUrls: ['./private-event-resend-requested-payment-email-modal.component.css']
})
export class PrivateEventResendRequestedPaymentEmailModalComponent {

  @Input() requestedPaymentId: number;
  @Input() bookingCustomerEmail: string;
  // False for a request created without a recipient email (PRO-1387), where
  // this modal sends the notification for the first time rather than resends.
  @Input() hasBeenEmailed = true;
  // Called after the email is successfully resent. Passed back so the parent
  // component can refresh / show a confirmation toast.
  @Input() submitCallback: () => void;

  public readonly RecipientOption = RecipientOption;

  public recipientOption: RecipientOption = RecipientOption.bookingCustomer;
  public manualEmail = '';

  public loading = false;
  public errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    private paymentService: PaymentService
  ) {}

  public getRecipientEmail(): string {
    if (this.recipientOption === RecipientOption.manual) {
      return this.manualEmail.trim();
    }
    return this.bookingCustomerEmail;
  }

  public onSubmit() {
    this.errorMessage = '';

    const recipientEmail = this.getRecipientEmail();
    if (!recipientEmail) {
      this.errorMessage = 'A recipient email is required.';
      return;
    }
    if (this.recipientOption === RecipientOption.manual) {
      const looksLikeEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail);
      if (!looksLikeEmail) {
        this.errorMessage = 'Enter a valid email address.';
        return;
      }
    }

    this.loading = true;

    this.paymentService
      .resendRequestedPaymentEmail(this.requestedPaymentId, recipientEmail)
      .then(() => {
        if (this.submitCallback) {
          this.submitCallback();
        }
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.error && reason.error.useful_error_message) {
          this.errorMessage = reason.error.useful_error_message;
        } else {
          this.errorMessage = 'Failed to resend email.';
        }
      })
      .finally(() => { this.loading = false; });
  }
}
